import React, { FC } from 'react';
import { User } from 'api/models';
import { Avatar } from 'components/atoms/avatar';
import { Strong } from '../basics';

export const Causer: FC<{
  user: Pick<User, 'firstName' | 'lastName' | 'photoUrl'>;
}> = ({ user: { firstName, lastName, photoUrl } }) => (
  <>
    <Avatar size="small" name={`${firstName} ${lastName}`} src={photoUrl} />
    <Strong>{firstName}</Strong>
  </>
);
